import { useState } from 'react';
import { Button, ButtonProps } from 'views/components/atoms/button';

type BankSelectProps = {
  brokerInfoList: { code: string; name: string }[];
  onSelected: React.Dispatch<React.SetStateAction<{ code: string; name: string }>>;
  onClickPrev: () => void;
  nextBtnProps?: ButtonProps;
};
export const BankInfoSelect = (props: BankSelectProps) => {
  const { brokerInfoList, onSelected, onClickPrev, nextBtnProps } = props;
  // 選択された要素の表示を変える用
  const [selectedCode, setSelectedCode] = useState<string>();

  return (
    <div className="bankInfoSelect">
      <div className="bankInfoSelect_listWrapper">
        <ul className="bankInfoSelect_ul">
          {brokerInfoList.map((item) => (
            <li
              className={`bankInfoSelect_li ${item.code === selectedCode ? 'selected' : ''}`}
              key={item.code}
              value={item.code}
              onClick={() => {
                onSelected(item);
                setSelectedCode(item.code);
              }}
            >
              {item.name}
            </li>
          ))}
        </ul>
      </div>
      <div className="bankInfoSelect_button">
        <div className="bankInfoSelect_backLink" onClick={() => onClickPrev()}>
          もどる
        </div>
        <Button {...nextBtnProps} />
      </div>
    </div>
  );
};
